import {chainPush, chainExecute} from "@/FunctionKit.js"
import {initUser, initRouter} from "@/RouterManager.js"
import {setEmpowerBg} from "@/InitBg.js"
import crossPageInteraction from "@/CrossPageInteraction.js"

	import 'assets/style/common/reset.scss';
	import set from 'lodash-es/set';
	if (window.self === window.top)
	{
	    window.initIframe = false;
	}
    set(window, 'top.Empower.utils.crossPageInteraction', crossPageInteraction);
	set(window, 'top.Empower.utils.setEmpowerBg', setEmpowerBg);
	setEmpowerBg()
	function process()
	{
	    try
	    {
	        const isIframe = window.top !== window.self;
	        const url = window.location.href;
	        chainPush([initUser]);
	        if (!isIframe)
	        {
	            chainPush(initRouter);
	        }
	        chainExecute();
	    }
	    catch (error)
	    {
	        console.log('core error', error);
	    }
	}
	process();

